<div class="container-fluid p-0">
  <div class="row">
    <div class="col-12">
      <div class="login-card">
        <div>
          <div>
            <a class="logo" routerLink="/">
              <img
                class="img-fluid for-light"
                src="assets/images/logo/logo.png"
                alt="paginadelogin"
              />
              <img
                class="img-fluid for-dark"
                src="assets/images/logo/logo_dark.png"
                alt="paginadelogin"
              />
            </a>
          </div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="loginForm">
              <h4>Para Representantes</h4>
              <p>Digite seu usuário e senha para fazer login</p>
              <div class="form-group">
                <label class="col-form-label">Usuário</label>
                <input
                  class="form-control rounded-pill"
                  type="text"
                  required=""
                  placeholder="Digite seu usuário"
                  formControlName="usuario"
                />
                <div
                  *ngIf="
                    loginForm.controls.usuario.touched &&
                    loginForm.controls.usuario.errors?.required
                  "
                  class="text text-danger mt-1"
                >
                  Usuário é obrigatório
                </div>
              </div>
              <div class="form-group">
                <label class="col-form-label">Senha</label>
                <div class="position-relative">
                  <input
                    class="form-control rounded-pill pr-5"
                    [type]="show ? 'text' : 'password'"
                    formControlName="senha"
                    required=""
                    placeholder="*********"
                    style="padding-right: 2.5rem"
                  />
                  <span
                    (click)="showPassword()"
                    style="
                      position: absolute;
                      top: 50%;
                      right: 18px;
                      transform: translateY(-50%);
                      cursor: pointer;
                      color: #888;
                    "
                  >
                    <i [ngClass]="show ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                  </span>
                </div>
                <div
                  *ngIf="
                    loginForm.controls.senha.touched &&
                    loginForm.controls.senha.errors?.required
                  "
                  class="text text-danger mt-1"
                >
                  Senha é obrigatória
                </div>
              </div>
              <div class="form-group mb-0">
                <div class="text-end mt-3">
                  <button
                    class="btn btn-primary d-block w-100 rounded-pill"
                    [disabled]="!loginForm.valid"
                    (click)="login()"
                    type="button"
                  >
                    <span>Entrar</span>
                  </button>
                </div>
              </div>
              <p class="mt-4 mb-0">
                Não tem uma conta?
                <a [routerLink]="'/auth/register'" class="ms-2">Criar Conta</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
